import { round } from "utils";

export function subscribeToAudioLevel(stream, listener) {
    const AudioContext = window.AudioContext || window.webkitAudioContext;

    const audioContext = new AudioContext();

    const analyser = audioContext.createAnalyser();
    const microphone = audioContext.createMediaStreamSource(stream);
    const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

    analyser.smoothingTimeConstant = 0.8;
    analyser.fftSize = 1024;

    microphone.connect(analyser);
    analyser.connect(scriptProcessor);
    scriptProcessor.connect(audioContext.destination);
    scriptProcessor.onaudioprocess = function () {
        const array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        const arraySum = array.reduce((a, value) => a + value, 0);
        const average = arraySum / array.length;
        listener(round(average));
    };

    return () => {
        scriptProcessor.disconnect();
        audioContext.close().then(() => {
            stream.getTracks().forEach(track => track.stop());
        }).catch(err => console.error('Error closing AudioContext:', err));
    };
}

export function nextStepAudio() {
    const audio = new Audio('https://assets.languify.in/audio/next_step_two.wav');
    audio.play().catch((error) => {
      console.error("Error playing audio:", error);
    });
  }